import { useCallback } from "react"
import { useNavigate } from "react-router-dom"
import Swal from "sweetalert2"
import { auth } from "../auth/auth"

export function useLogout() {
  const navigate = useNavigate()

  return useCallback(async () => {
    auth.logout()

    await Swal.fire({
      icon: "success",
      title: "Logged out",
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
    })

    navigate("/login", { replace: true })
  }, [navigate])
}
